export const HEADER_FIXED = [
  "年度",
  "収入/支出",
  "カテゴリ",
  "明細項目",
  "予算/実績",
] as const;

export const FIXED_COLUMN_COUNT = HEADER_FIXED.length;
export const MONTH_COLUMN_COUNT = 12;
export const TOTAL_COLUMN_COUNT = FIXED_COLUMN_COUNT + MONTH_COLUMN_COUNT;

export const ROW_KIND_BUDGET = "予算" as const;
export const ROW_KIND_ACTUAL = "実績" as const;
export const ROW_KINDS = [ROW_KIND_BUDGET, ROW_KIND_ACTUAL] as const;

export const GROUP_INCOME = "収入" as const;
export const GROUP_EXPENSE = "支出" as const;
export const GROUPS = [GROUP_INCOME, GROUP_EXPENSE] as const;

export const COMMENT_MARKER = "#";
export const BOM = "﻿";

// テンプレート/エクスポートの「説明」ブロック (ヘッダー行より前)。
// アップロード表 (アップロード表_改修版.csv) に合わせ、# ではなく ■/・ 表記。
// パーサーはヘッダー (1列目 "年度") より前の行を全てスキップするため、これらは取込に影響しない。
export const TEMPLATE_COMMENT_LINES = [
  "【予実管理アップロードテンプレート】",
  "",
  "■ 使い方",
  "・新規に入力する場合：このファイルのヘッダー行（「年度」から始まる行）の下に、1行ずつ値を記入してください。",
  "・既存データを修正する場合：「現在のデータ」をダウンロードし、各行の金額などを編集して保存してください。",
  "・ヘッダー行より上のこの説明部分は編集・削除不要です（アップロード時に自動で無視されます）。",
  "・編集後、画面のアップロード欄にこのファイルをそのままアップロードしてください。",
  "",
  "■ 項目について",
  "・年度(必須)：登録する年度を入力します。",
  "・収入/支出(必須)：「収入」または「支出」を入力します。",
  "・カテゴリ(必須)：予実管理にあるカテゴリを記載します。支出は未登録のカテゴリでも新規追加されます（収入は登録済のカテゴリのみ・未登録はエラー）。",
  "・明細項目(必須)：カテゴリ配下の明細科目名を入力します。支出は未登録の明細科目でも新規追加されます（収入は登録済の項目のみ・未登録はエラー）。",
  "・予算/実績(必須)：「予算」または「実績」を入力します。",
  "・各月の金額(任意)：全角半角どちらも入力できます。空欄は未入力扱いとなり、小数点以下は切り捨てます。複数月をまとめて入力できます。",
  "",
  "■ アップロード表（下記に記載すること）",
];
